import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import styled from "styled-components";
import useActivityLogger from "../../hooks/useActivityLogger";
import { captureAffiliateRefFromSearch } from "../../config/affiliateRef";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BackToTop from "../shared/BackToTop";
import CookieConsent from "../shared/CookieConsent";
import { PageRoot } from "./PageLayout.styles";

const Main = styled.div`
  flex: 1;
  min-height: 0;
`;

export default function PageLayout() {
  const location = useLocation();
  useEffect(() => {
    captureAffiliateRefFromSearch(location.search);
  }, [location.search]);

  useActivityLogger();

  return (
    <PageRoot>
      <Navbar />
      <Main>
        <Outlet />
      </Main>
      <Footer />
      <BackToTop />
      <CookieConsent />
    </PageRoot>
  );
}
